export var RESOLVABLE_TREE_PRIVATE = Symbol('resolvable-tree-private');
//# sourceMappingURL=privates.js.map